var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{class:_vm.$attrs['disabled'] ? 'disabled' : '',attrs:{"src":_vm.portraitUrl,"aspect-ratio":3 / 4}})
}
var staticRenderFns = []

export { render, staticRenderFns }